// extracted by mini-css-extract-plugin
export default {"adminMenuContainer":"a2u5S4SgpbE6Z0XQ182g","menuList":"L6M4O5KmrypVrdJDR3tC"};